var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkrepkaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.51 13.818c0 1.734-.61 3.209-1.826 4.425-1.216 1.217-2.691 1.825-4.425 1.825-1.733 0-3.208-.608-4.425-1.825C.618 17.027.01 15.552.01 13.818v-9.25c0-1.25.438-2.312 1.313-3.187S3.259.068 4.509.068s2.313.438 3.188 1.313 1.312 1.937 1.312 3.187v8.75c0 .767-.266 1.417-.8 1.95-.533.534-1.183.8-1.95.8a2.654 2.654 0 01-1.95-.8 2.654 2.654 0 01-.8-1.95v-9.25h2v9.25a.729.729 0 00.75.75.729.729 0 00.75-.75v-8.75c-.016-.7-.262-1.291-.737-1.775-.475-.483-1.063-.725-1.763-.725s-1.291.242-1.775.725a2.416 2.416 0 00-.725 1.775v9.25c-.016 1.184.392 2.188 1.225 3.013.834.825 1.842 1.237 3.025 1.237 1.167 0 2.159-.412 2.975-1.237.817-.825 1.242-1.83 1.275-3.013v-9.75h2v9.75z",
    fill: "#9390A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkrepkaIcon);
export default __webpack_public_path__ + "static/media/skrepka-icon.932cc6c558a2b5194646235e12d1f608.svg";
export { ForwardRef as ReactComponent };